import React, { useEffect, useRef } from "react";
import { RouterProvider } from "react-router-dom";
import router from "@/routes";
import "@/styles/App.css";
import { useAuthStore } from "./stores/authStore";
import AuthDebugger from "./components/AuthDebugger";
import SessionWarning from "./components/SessionWarning";

import logger from "./utils/secureLogger";
function App() {
  const { initializeAuth, resetAuthState, loading } = useAuthStore();
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Prevent multiple initializations
    if (hasInitialized.current) {
      return;
    }

    const initAuth = async () => {
      try {
        hasInitialized.current = true;
        logger.debug("🚀 App starting, initializing authentication...");
        
        // Set a timeout to prevent infinite loading
        const timeoutId = setTimeout(() => {
          logger.debug("⚠️ Auth initialization timeout, resetting state...");
          resetAuthState();
        }, 10000); // 10 seconds timeout
        
        await initializeAuth();
        
        // Clear timeout if initialization completes successfully
        clearTimeout(timeoutId);
        
      } catch (error) {
        logger.error("❌ Failed to initialize auth in App:", error);
        hasInitialized.current = false; // Allow retry on error
        resetAuthState(); // Reset state on error
      }
    };
    
    initAuth();
  }, []); // Empty dependency array to run only once

  // Skip global loading spinner - auth pages handle their own loading states
  return (
    <>
      <RouterProvider router={router} />
      <SessionWarning />
      <AuthDebugger />
    </>
  );
}

export default App;
